import React from 'react'

import { AreaChartWidget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { padTimeSeries } from 'modules/ticketing/lib/padTimeSeries'

type ActivityPoint = {
  label: string
  openedCount: number
  closedCount: number
}

type Props = {
  data: ActivityPoint[]
  period: string
}

export const InsightsTicketActivityChart: React.FC<Props> = ({ data, period }) => {
  const paddedData = padTimeSeries(data, period, { openedCount: 0, closedCount: 0 })

  const MAX_LABELS = 6
  const step = Math.max(1, Math.ceil(paddedData.length / MAX_LABELS))

  const chartData = paddedData.map((point, index) => ({
    label: index % step === 0 || index === paddedData.length - 1 ? point.label : '',
    values: {
      opened: point.openedCount,
      closed: point.closedCount,
    },
  }))

  return (
    <AreaChartWidget
      header={{
        title: i18n.t('ticketing.inbox.insights.charts.ticket_activity'),
      }}
      chart={{
        data: chartData,
        dataConfig: {
          opened: {
            label: i18n.t('ticketing.inbox.insights.charts.opened'),
            color: 'categorical-1',
          },
          closed: {
            label: i18n.t('ticketing.inbox.insights.charts.closed'),
            color: 'categorical-3',
          },
        },
      }}
    />
  )
}
